module.exports = new Promise((resolve, reject) => {
      // Logic for dynamic resolution in non-dev environments
      const remoteUrl = window.location.origin + '/design-system/remoteEntry.js';

      if (window['framework_design_system']) {
          return resolve({
              get: (request) => window['framework_design_system'].get(request),
              init: (arg) => {
                  try {
                      return window['framework_design_system'].init(arg);
                  } catch(e) {
                      console.log('Remote container already initialized');
                  }
              }
          });
      }

      const existingScript = document.querySelector(`script[src="${remoteUrl}"]`);
      if (existingScript) {
          existingScript.addEventListener('load', () => {
              resolve({
                  get: (request) => window['framework_design_system'].get(request),
                  init: (arg) => {
                      try {
                          return window['framework_design_system'].init(arg);
                      } catch(e) {
                          console.log('Remote container already initialized');
                      }
                  }
              });
          });
          existingScript.addEventListener('error', () => {
              console.warn('Failed to load remote: framework_design_system from ' + remoteUrl);
              reject(new Error('Failed to load remote: framework_design_system'));
          });
          return;
      }

      const script = document.createElement('script');
      script.src = remoteUrl;
      script.crossOrigin = 'anonymous';
      script.onload = () => {
          resolve({
              get: (request) => window['framework_design_system'].get(request),
              init: (arg) => {
                  try {
                      return window['framework_design_system'].init(arg);
                  } catch(e) {
                      console.log('Remote container already initialized');
                  }
              }
          });
      };
      script.onerror = () => {
          console.warn('Failed to load remote: framework_design_system from ' + remoteUrl);
          reject(new Error('Failed to load remote: framework_design_system'));
      };
      document.head.appendChild(script);
  });